module.exports = __webpack_public_path__ + "static/media/preguntas_frecuentes_new.27a262f9.png";